import axios, { AxiosResponse } from "axios";

import API from "./api";

import { IAPI } from "./IAPI";
import notification from "antd/es/notification";

const DocumentsAPI = (baseUrl: IAPI) => {
  const api = API(baseUrl);

  const getVideo = (vieoName: string, containerName: string) => {
    return new Promise((resolve, reject) => {
      const instance = axios.create();
      delete instance.defaults.headers.common["Authorization"];
      instance
        .get(
          `https://services.qualitasfunds.com/api/DataRoom?vieoName=${vieoName}&containerName=${containerName}`
        )
        .then((data) => (data !== null ? resolve(data) : reject(null)));
    });
  };

  const getDataRoomVideos = (list: string) => {
    const serviceUrl =
      "https://services-dev.qualitasfunds.com/api/investors/sharepoint/getlistvideos";
    return axios
      .get(serviceUrl, { params: { list } })
      .then((response: AxiosResponse) => response.data.result)
      .catch((error) =>
        notification.error({
          message: "Error",
          description: `Failed to fetch data room videos: ${error.message}`,
        })
      );
  };

  const getUserDocuments = (userInstitutionName: string) => {
    const serviceUrl = "/documentsystem-api/Documents/FileList";
    return api
      .get(serviceUrl, { params: { folder: userInstitutionName } })
      .then((response: AxiosResponse) => response.data)
      .catch((error) =>
        notification.error({
          message: "Error",
          description: `Failed to fetch user documents: ${error.message}`,
        })
      );
  };

  return {
    getVideo,
    getDataRoomVideos,
    getUserDocuments,
  };
};

export default DocumentsAPI;
